import { Host, forceUpdate, h } from "@stencil/core";
import { RemoteParticipant, Track } from "livekit-client";
import { removeElement } from "../../common/array";
import { connectToRoom } from "./connect";
export class ChLiveKitRoom {
    constructor() {
        this.callbacks = undefined;
        this.connected = false;
        this.microphoneEnabled = false;
        this.token = "";
        this.url = "";
    }
    el;
    #currentRoom;
    #participants = [];
    connectedChanged() {
        if (this.connected) {
            this.#connect();
        }
        else {
            this.#disconnectRoom();
        }
    }
    microphoneEnabledChanged() {
        if (this.connected) {
            this.#toggleLocalParticipantMic();
        }
    }
    #addOrRemoveParticipant = (participant, action) => {
        const participantIndex = this.#findParticipantIndex(participant);
        if (action === "add") {
            if (participantIndex === -1) {
                this.#participants.push({ participant, shouldUpdate: true });
            }
            else {
                this.#participants[participantIndex].shouldUpdate = true;
            }
        }
        else {
            removeElement(this.#participants, participantIndex);
        }
        forceUpdate(this);
    };
    #connect = () => connectToRoom(this.url, this.token, this.#addOrRemoveParticipant, this.callbacks).then(room => {
        this.#currentRoom = room;
        this.#toggleLocalParticipantMic();
    });
    #disconnectRoom = () => {
        if (this.#currentRoom) {
            this.#currentRoom.disconnect();
        }
    };
    #findParticipantIndex = (participant) => this.#participants.findIndex(p => p.participant.identity === participant.identity);
    #toggleLocalParticipantMic = () => this.#currentRoom?.localParticipant.setMicrophoneEnabled(this.microphoneEnabled);
    connectedCallback() {
        if (this.connected) {
            this.#connect();
        }
    }
    componentDidRender() {
        this.#participants.forEach(participant => {
            if (participant.shouldUpdate) {
                participant.shouldUpdate = false;
                if (!participant.participant.isLocal) {
                    if (participant.participant instanceof RemoteParticipant) {
                        participant.participant.setVolume(1);
                    }
                    const micPub = participant.participant.getTrackPublication(Track.Source.Microphone);
                    micPub?.audioTrack?.attach(participant.ref);
                }
            }
        });
    }
    disconnectedCallback() {
        if (this.connected) {
            this.#disconnectRoom();
        }
    }
    render() {
        return (h(Host, { key: 'cde5479dcfc523dd52ece9855bd3c0463c6eb9c7' }, h("slot", { key: '435db75de7c431bc0d41b00fa0f41f2c69107f04' }), this.#participants.map(participant => (h("audio", { key: participant.participant.identity, ref: el => (participant.ref = el) })))));
    }
    static get is() { return "ch-live-kit-room"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["live-kit-room.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["live-kit-room.css"]
        };
    }
    static get properties() {
        return {
            "callbacks": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "LiveKitCallbacks | undefined",
                    "resolved": "{ activeSpeakersChanged?: (participant: Participant[]) => void; connectionEvents?: LiveKitConnectionListener; muteMic?: () => void; unmuteMic?: () => void; updateTranscriptions?: (segments: TranscriptionSegment[], participant?: Participant, publication?: TrackPublication) => void; }",
                    "references": {
                        "LiveKitCallbacks": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/live-kit-room/types.ts::LiveKitCallbacks"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Specifies the callbacks required in the control."
                }
            },
            "connected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the room state."
                },
                "attribute": "connected",
                "reflect": false,
                "defaultValue": "false"
            },
            "microphoneEnabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the microphone state."
                },
                "attribute": "microphone-enabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "token": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the token to connect to the room"
                },
                "attribute": "token",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the url to connect to the room"
                },
                "attribute": "url",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "connected",
                "methodName": "connectedChanged"
            }, {
                "propName": "microphoneEnabled",
                "methodName": "microphoneEnabledChanged"
            }];
    }
}
